interface Props {
  size?: number;
  className?: string;
}

export function Spinner({ size = 18, className = "" }: Props) {
  return (
    <span
      role="status"
      aria-label="Caricamento"
      className={`inline-block animate-spin rounded-full border-2 border-current border-r-transparent ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
